import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ProfiledService } from '../db/models/profiled-service';

@Injectable({
  providedIn: 'root'
})
export class ProfiledServiceService {

  headers = new HttpHeaders()
  .set('Content-Type','application/json')
  .set('Access-Control-Allow-Origin','*')

  // private baseUrl = 'https://localhost:44352/api/profiledService/';
private baseUrl = 'https://api.trepezserver.com/api/profiledService/';

constructor(private http: HttpClient) { }


createManagedService(data: ProfiledService): Observable<ProfiledService> {
  return this.http.post<ProfiledService>(this.baseUrl + 'newProfileService', data, { 'headers': this.headers });
}

}
